import React from "react";

function DownloadIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="36" height="36" rx="18" fill="#E8ECF4"/>
      <rect x="2" y="2" width="40" height="40" rx="20" stroke="#E8ECF4" strokeOpacity="0.5" strokeWidth="4"/>
      <path d="M31 24.8333V28.6111C31 29.1121 30.7893 29.5925 30.4142 29.9468C30.0391 30.301 29.5304 30.5 29 30.5H15C14.4696 30.5 13.9609 30.301 13.5858 29.9468C13.2107 29.5925 13 29.1121 13 28.6111V24.8333M17 20.1111L22 24.8333M22 24.8333L27 20.1111M22 24.8333V13.5" stroke="#18468F" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default DownloadIcon;
